import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { ReactFCV } from '@types';
import { FATAL_ERROR_BACKGROUND_IMG } from '@utils/constants';
import { stopPropagationMouseEvent } from '@utils/general';
import { formatUrl } from '@utils/text';

import { useErrorContext } from '../../../../ErrorContext';
import { FATAL_ERROR_CODE } from '../../constants';
import { messages } from '../../messages';
import { NavigationLink } from '../NavigationLink';

import { Wrapper, Title, Description, ErrorCode, Links } from './styled';

export interface IFatalErrorProps extends IBasicStyledProps {
  errorCode?: number;
}

export const FatalError: ReactFCV<IFatalErrorProps> = ({ errorCode = FATAL_ERROR_CODE, ...rest }) => {
  const {
    settings: { cdnBaseUrlAddress },
  } = useApplicationBuildContext();
  const { setFatalError } = useErrorContext();
  const navigate = useNavigate();

  const handleGoBack = () => {
    setFatalError(false);
    navigate(-1);
  };

  return (
    <Wrapper {...rest} backgroundImageUrl={formatUrl({ urlBase: cdnBaseUrlAddress, path: FATAL_ERROR_BACKGROUND_IMG })}>
      <Title>
        <FormattedMessage {...messages.fatalErrorTitle} />
      </Title>
      <Description>
        <FormattedMessage {...messages.fatalErrorDescription} />
      </Description>
      <ErrorCode>
        <FormattedMessage {...messages.fatalErrorCode} values={{ errorCode }} />
      </ErrorCode>
      <Links>
        <NavigationLink href="/" onClick={stopPropagationMouseEvent} message={messages.fatalErrorLinkHomePage} />
        <NavigationLink href="#" onClick={handleGoBack} message={messages.fatalErrorLinkPreviousPage} />
      </Links>
    </Wrapper>
  );
};
